import React from 'react'
import { ContentfulModules } from '../helpers/modules'
import { useEntities } from '../helpers/selectors'
import { removeWhitespaceAndSpecialChars } from '../helpers/commons'
import { Select } from '../../atoms'

const Pills = ({ name, pills = [] }) => {
  const { buttons, panels } = pills.reduce<{ buttons: JSX.Element[]; panels: JSX.Element[] }>(
    (result, { modules, title }, index) => {
      result.buttons.push(
        <button key={index} className={`Pills__pill ${index === 0 ? 'Pills__pill-active' : ''}`}>
          {title}
        </button>,
      )
      result.panels.push(
        <div key={index} className={`Panels__panel ${index === 0 ? 'Panels__panel-active' : ''}`}>
          {modules && <ContentfulModules modules={modules} />}
        </div>,
      )
      return result
    },
    { buttons: [], panels: [] },
  )

  const dropdownOptions = pills.map((p) => ({ text: p.title, value: p.title }))

  return (
    <div className='PillsContainer' data-pills id={removeWhitespaceAndSpecialChars(name)}>
      <div className='Pills'>{buttons}</div>

      <div className='Dropdown'>
        <Select
          name='pills-mobile-dropdown'
          value={dropdownOptions.length > 0 ? dropdownOptions[0].value : ''}
          options={dropdownOptions}
          brand='money'
        />
      </div>

      <div className='Panels'>{panels}</div>
    </div>
  )
}

const PillsConnected = ({ name, entries }) => {
  const pills = useEntities(entries)

  return <Pills name={name} pills={pills} />
}

export default PillsConnected
